module.exports = __webpack_public_path__ + "static/media/header_girl.73e08fa2.png";